// src/features/pinFeatureSummary.js
// Produces a compact, stable string summary per pin.
// This is what we can embed later AND what we can aggregate/report on now.

function asArray(v) {
  if (!v) return [];
  if (Array.isArray(v)) return v.filter(Boolean);
  if (typeof v === "string") return v.split(/[,|]/).map(s => s.trim()).filter(Boolean);
  return [];
}

function pickString(v) {
  if (!v) return "";
  if (typeof v === "string") return v.trim();
  return "";
}

function compactText(s, maxLen = 280) {
  const t = String(s || "").replace(/\s+/g, " ").trim();
  if (!t) return "";
  return t.length > maxLen ? t.slice(0, maxLen - 1) + "…" : t;
}

export function summarisePinFeatures(features) {
  if (!features) return "";

  // Notes should stay human-readable; they often already contain intent.
  const noteText = pickString(features.text || features.note);
  if (noteText) return compactText(noteText, 360);

  const parts = [];

  // Caption fallback (useful context even if structured exists)
  const caption = pickString(features.caption);
  if (caption) parts.push(`caption:${compactText(caption, 160)}`);

  // Structured fields (robust to various schemas)
  const garmentType = pickString(features.garmentType || features.type || features.category);
  const length = pickString(features.length);
  const fit = pickString(features.fit);

  const colors = asArray(features.colors || features.colorFamilies || features.palette);
  const materials = asArray(features.materials || features.fabrics);
  const keywords = asArray(features.keywords || features.tags || features.styleTags);
  const silhouettes = asArray(features.silhouette || features.silhouettes);

  if (garmentType) parts.push(`type:${garmentType}`);
  if (length) parts.push(`length:${length}`);
  if (fit) parts.push(`fit:${fit}`);
  if (silhouettes.length) parts.push(`silhouette:${silhouettes.slice(0, 3).join(",")}`);
  if (colors.length) parts.push(`colors:${colors.slice(0, 4).join(",")}`);
  if (materials.length) parts.push(`materials:${materials.slice(0, 3).join(",")}`);
  if (keywords.length) parts.push(`keywords:${keywords.slice(0, 6).join(",")}`);

  return parts.join(" | ");
}